export default "/img/NL.4fd0171c88ca011f70cee3bae12205e3.png";